import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ContainerReportFilter = _resolveComponent("ContainerReportFilter")!
  const _component_ContainerReportInfoDialog = _resolveComponent("ContainerReportInfoDialog")!
  const _component_Report = _resolveComponent("Report")!

  return (_openBlock(), _createBlock(_component_Report, {
    ref: "reportComponent",
    reportType: _ctx.reportType
  }, {
    reportSettings: _withCtx(({ loading, toggleInfoDialog }) => [
      _createVNode(_component_ContainerReportFilter, {
        onOnReport: _ctx.onReport,
        onOnStop: _ctx.onStop,
        loading: loading
      }, null, 8, ["onOnReport", "onOnStop", "loading"]),
      _createVNode(_component_ContainerReportInfoDialog, { toggleInfoDialog: toggleInfoDialog }, null, 8, ["toggleInfoDialog"])
    ]),
    _: 1
  }, 8, ["reportType"]))
}